import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
} from "reactstrap";
import { Link } from "react-router-dom";
import OrderManagementService from "../../../Services/QRCodeServices/Order Management/OrderManagementService";
import { useParams } from "react-router-dom";
import OrderStatusTimeline from "../component/OrderStatusTimeline";
import avatar3 from '../../../assets/images/users/avatar-3.jpg'

export const OrderDetail = ({ orderId }) => {
  const [data, setData] = useState({});
  
  useEffect(() => {
    if (!orderId) return;

    (async () => {
      try {
        const response = await OrderManagementService.detail(orderId);
        setData(response);
      } catch (error) {
        console.log("🚀 ~ error:", error);
      }
    })();
  }, [orderId]);

  if (!orderId) {
    return <div>Select an order to view details.</div>;
  }

  const totalAmount = data.menuOrderDetails?.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const customerData = data.customerData?.[0]; // Assuming there's only one customer

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col xl={9}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">{orderId}</h5>
                  <h5 className="mb-0 card-title d-flex gap-2 ">
                    <p className="fw-bold">Table:</p> {data.tableData?.identification || "N/A"}
                  </h5>
                </div>
              </CardHeader>
              <CardBody>
                <div className="table-responsive table-card">
                  <table className="table table-nowrap align-middle table-borderless mb-0">
                    <thead className="table-light text-muted">
                      <tr>
                        <th scope="col">Product Details</th>
                        <th scope="col">Item Price</th>
                        <th scope="col">Quantity</th>
                        <th scope="col" className="text-end">
                          Total Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.menuOrderDetails?.map((item) => (
                        <tr key={item.menuItemDetail.id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <img
                                src={item.menuItemDetail.cloudR2ImagePath.getCDNUrl()}
                                alt={item.menuItemDetail.title}
                                className="me-2"
                                width="50"
                              />
                              {item.menuItemDetail.title}
                            </div>
                          </td>
                          <td>{item.price.toFixed(2)} NRS</td>
                          <td>{item.quantity}</td>
                          <td className="text-end">
                            {(item.price * item.quantity).toFixed(2)} NRS
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tr>
                      <td colSpan='2'></td>
                      <td className="fw-semibold">
                        Sub Total:
                      </td>
                      <td className="text-end fw-semibold">
                        {totalAmount?.toFixed(2)} NRS
                      </td>
                    </tr>
                  </table>
                </div>
              </CardBody>
            </Card>
            <Card>
              <OrderStatusTimeline statusLogs={data.billingStatusLogDtos ? [data.billingStatusLogDtos] : []} />
            </Card>
          </Col>

          <Col xl={3}>
            <Card>
              <CardHeader>
                <div className="d-flex">
                  <h5 className="card-title flex-grow-1 mb-0">
                    Customer Details
                  </h5>
                  <div className="flex-shrink-0">
                    {/* <Link to="#" className="link-secondary">
                      View Profile
                    </Link> */}
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <ul className="list-unstyled mb-0 vstack gap-3">
                  <li>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img
                          src={avatar3}
                          alt=""
                          className="avatar-sm rounded"
                        />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h6 className="fs-15 mb-1">{customerData?.name || "N/A"}</h6>
                        <p className="text-muted mb-0">Customer</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <i className="ri-mail-line me-2 align-middle text-muted fs-16"></i>
                    {customerData?.email || "N/A"}
                  </li>
                  <li>
                    <i className="ri-phone-line me-2 align-middle text-muted fs-16"></i>
                    {customerData?.phoneNumber || "N/A"}
                  </li>
                  <li>
                    <i className="ri-map-pin-line me-2 align-middle text-muted fs-16"></i>
                    {customerData?.address || "N/A"}
                  </li>
                </ul>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">
                  <i className="ri-secure-payment-line align-bottom me-1 text-muted"></i>{" "}
                  Payment Details
                </h5>
              </CardHeader>
              <CardBody>
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Transactions:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <h6 className="mb-0">#VLZ124561278124</h6>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Payment Method:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <h6 className="mb-0">Debit Card</h6>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Card Holder Name:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <h6 className="mb-0">Joseph Parker</h6>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Card Number:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <h6 className="mb-0">xxxx xxxx xxxx 2456</h6>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0">
                    <p className="text-muted mb-0">Total Amount:</p>
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <h6 className="mb-0">$415.96</h6>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};